import { Route } from "react-router-dom";
import { pages } from "../../../utils/common";
import LocalizationView from "./localization.view";

const useLocalizationRoutes = () => (
  <Route path={pages.localization.path} element={<LocalizationView />}>
    <Route index element={<LocalizationView />} />
  </Route>
);

export default useLocalizationRoutes;
